// extracted by mini-css-extract-plugin
module.exports = {"container":"WaitingListPage_container__3QMWe","header":"WaitingListPage_header__1wKpS","logout":"WaitingListPage_logout__2W5rb","button":"WaitingListPage_button__3dsiK"};